/* Foundation v2.1.3 http://foundation.zurb.com */
$(document).ready(function () {

	/* Use this js doc for all application specific JS */

	/* TABS --------------------------------- */
	/* Remove if you don't need :) */

	function activateTab($tab) {
	  var $activeTab = $tab.closest('dl').find('a.active'),
	      contentLocation = $tab.attr("href") + 'Tab';

	  //Make Tab Active
	  $activeTab.removeClass('active');
	  $tab.addClass('active');

    //Show Tab Content
		$(contentLocation).closest('.tabs-content').find('li').hide();
		$(contentLocation).show();
	}

	$('dl.tabs').each(function () {
		//Get all tabs
		var tabs = $(this).children('dd').children('a');
		tabs.click(function (e) {
		  activateTab($(this));
		});
	});

	if (window.location.hash) {
    activateTab($('a[href="' + window.location.hash + '"]'));
  }


	/* PLACEHOLDER FOR FORMS ------------- */
	/* Remove this and jquery.placeholder.min.js if you don't need :) */

	$('input, textarea').placeholder();
	$('#toTop').click(function() {
		$('body,html').animate({scrollTop:0},800);
	});
	
    jQuery(document).ready(function() {
	    // Image swap on hover
	    jQuery(".product-thumbs ul li img").click(function(){
	        jQuery('.product-img img').attr('src',jQuery(this).attr('title'));
	    });
	    // Image preload
	    var imgSwap = [];
	     jQuery(".product-thumbs ul li a").each(function(){
	        imgUrl = this.title;
	        imgSwap.push(imgUrl);
	    });
	    jQuery(imgSwap).preload();
	});
	$.fn.preload = function() {
	    this.each(function(){
	        jQuery('<img/>')[0].src = this;
	    });
	}
});
	jQuery(document).ready(function() {
		jQuery('div.cart-item:odd').addClass('odd');
	});
    $(window).load(function() {
        $('#slider').orbit({
			timer: true,
			directionalNav: false,
			bullets: false,
			animation: 'fade',
			advanceSpeed: 3500,
			animationSpeed: 1000
		});
		 $('.secondary-slider').orbit({
			timer: true,
			directionalNav: false,
			bullets: true,
			animation: 'fade',
			advanceSpeed: 3500,
			animationSpeed: 1000
		});
    });